import { LoversApi } from "api/LoversApi"
import { useEffect } from "react"
import { create } from "zustand"
import { persist } from "zustand/middleware"
interface AuthState {
  isAuthenticated: boolean
  isInitializing: boolean
  refetchAccessToken: () => Promise<void>
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  signUp: (data: { name: string; email: string; password: string }) => Promise<void>
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isInitializing: true,
      refetchAccessToken: async () => {
        try {
          await LoversApi().refresh.refreshTokens()
          set({ isAuthenticated: true, isInitializing: false })
        } catch (error) {
          set({ isAuthenticated: false, isInitializing: false })
          throw error
        }
      },
      login: async (email: string, password: string) => {
        try {
          await LoversApi().login.loginUser({ email, password })
          set({ isAuthenticated: true, isInitializing: false })
        } catch (error) {
          set({ isAuthenticated: false, isInitializing: false })
          throw error
        }
      },
      logout: async () => {
        try {
          await LoversApi().logout.logoutUser()
          set({ isAuthenticated: false, isInitializing: false })
        } catch (error) {
          set({ isAuthenticated: false, isInitializing: false })
          throw error
        }
      },
      signUp: async (data) => {
        try {
          await LoversApi().user.createUser({
            name: data.name,
            email: data.email,
            password: data.password
          })
          set({ isAuthenticated: true, isInitializing: false })
        } catch (error) {
          set({ isAuthenticated: false, isInitializing: false })
          throw error
        }
      }
    }),
    {
      name: "auth-store"
    }
  )
)

// Authentication hook
export const useAuth = () => {
  const { isAuthenticated, isInitializing, refetchAccessToken, login, logout, signUp } =
    useAuthStore()

  // Initial token check on component mount
  useEffect(() => {
    if (isInitializing) {
      refetchAccessToken()
    }
  }, [isInitializing, refetchAccessToken])

  return {
    isAuthenticated,
    isInitializing,
    refetchAccessToken,
    login,
    logout,
    signUp
  }
}
